import React, { useEffect, useState } from 'react';
import {  Row, Col, Layout, List, Checkbox, Input, Button,Tag, Switch, TimePicker, Modal ,Select,Divider,Table, notification  } from 'antd';
import { Typography } from 'antd';
import dayjs from 'dayjs';

import { DatePicker } from 'antd';

import axios from 'axios';

import AppHeader from '../../components/appHeader/AppHeader.jsx';
import { useNavigate } from 'react-router-dom';
import '../../styles/responsive.scss';
import '../../styles/table-responsive.scss';

const { Option } = Select;

  
  // 用于初始化每天的时间段安排
const initialSchedule = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => ({ day, timeSlots: [] }));



const AdminMenuGroup = () => {
    const { Link } = Typography;
    const { RangePicker } = DatePicker;
  const [cusId, setCusId] = useState('');
  const [cusEmail, setCusEmail] = useState('');
  const [menuGroupItems, setMenuGroupItems] = useState([]);
  const [existingGroup, setExistingGroup] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [schedule, setSchedule] = useState(initialSchedule);
  const navigate = useNavigate();
  const processExistingCategoryData = (data) => {
    const result = [];

    data.forEach((item) => {
      const existingCategory = result.find(category => category.CategoryId === item.CategoryId);
      if (existingCategory) {
        existingCategory.MenuGroups += `, ${item.ItemDescription}`;
      } else {
        result.push({
          CategoryId: item.CategoryId,
          CategoryName: item.CategoryName,
          MenuGroups: item.ItemDescription,
          ServiceType: item.ServiceType,
        });
      }
    });

  
    return result;
  };
  const columns = [
    {
      title: 'Category Name',
      dataIndex: 'CategoryName',
      key: 'CategoryName',
    },
    {
        title: 'Menu Groups',
        key: 'MenuGroups',
        // render: (_, record) => (
        //   <>
        //     {record.MenuGroups.split(', ').map((itemDescription, index) => (
        //       <Tag color="orange" key={index}>
        //         {itemDescription}
        //       </Tag>
        //     ))}
        //   </>
        // ),

        render: (_, record) => (
          <>
            {(record.MenuGroups || '').split(', ').map((itemDescription, index) => (
              itemDescription && (
                <Tag color="orange" key={index}>
                  {itemDescription}
                </Tag>
              )
            ))}
          </>
        ),
    },
    {
        title: 'Service Type (Dine in/Take away)',
        dataIndex: 'ServiceType',
        key: 'ServiceType',
        render: (_, record) => {
          return (
            <Select
              defaultValue={record.ServiceType === null ? "both" : record.ServiceType.toString()}
              style={{ width: 120 }}
              onChange={(value) => handleServiceTypeChange(value, record.CategoryId)}
            >
              <Option value="both">Both</Option>
              <Option value="0">Dine in</Option>
              <Option value="1">Take away</Option>
            </Select>
          );
        },
      },
      
    
    {
        title: 'Operation',
        key: 'operation',
        render: (_, record) => (
            <Link onClick={() => handleDelete(record.CategoryId)} style={{ color: '#1677ff' }}>
            Delete
          </Link>
        ),
      },
  ];

  const handleServiceTypeChange = async (value, categoryId) => {
    try {
      const token = sessionStorage.getItem('jwtToken');
      const serviceType = value === "both" ? null : Number(value);
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/update-menu-group-category-service-type`, {
        categoryId,
        serviceType,
      }, config);
  
      if (response.status === 200) {
        notification.success({
          message: 'Update Success',
          description: 'The service type has been successfully updated.',
        });
        // 这里可以添加代码来更新前端显示，如重新获取数据
      }
    } catch (error) {
      notification.error({
        message: 'Update Failed',
        description: 'An error occurred while updating the service type.',
      });
    }
  };
  
  const handleDelete = async (categoryId) => {
    try {
      const token = sessionStorage.getItem('jwtToken');
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/delete-menu-group-category/${categoryId}`, config);
  
      if (response.status === 200) {
         // 成功通知
        notification.success({
            message: 'Delete Success',
            description: 'The category has been successfully deleted.',
        });
      
        setExistingGroup(processExistingCategoryData(response.data.MenuGroupCategoryResult));
      }
    } catch (error) {
        notification.error({
            message: 'Delete Failed',
            description: 'An error occurred while deleting the category.',
          });
    }
  };
  
  
  useEffect(() => {
    const fetchMenuGroup = async () => {
        try {
            const token = sessionStorage.getItem('jwtToken');
            const config = {
            headers: {
                authorization: `Bearer ${token}`,
            },
            };
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetch-menu-group`, {}, config);
            if (response.status === 200) {
                const mappedItems = response.data.menuGroupItemResult.map(item => ({
                    ItemId: item.ItemId,
                    Code: item.Code, 
                    Description: item.Description, 
                    
                  }));
                setMenuGroupItems(mappedItems)
                setExistingGroup(processExistingCategoryData(response.data.MenuGroupCategoryResult));
               
                
                const newSchedule = schedule.map(day => {
                    // 筛选出与当前遍历日匹配的所有时间段
                    const savedTimeSlots = response.data.savedTimeSlotsResult.filter(slot => slot.DayOfWeek === day.day);
                  
                    return {
                      ...day,
                      timeSlots: savedTimeSlots.map(slot => ({
                        group: slot.CategoryId, 
                        startTime: dayjs('2000-01-01 ' + slot.StartTime).format('HH:mm'),
                        endTime: dayjs('2000-01-01 ' + slot.EndTime).format('HH:mm'),
                        isModified: false, 
                        timeSlotId: slot.TimeSlotId 
                      }))
                    };
                  });
                  
                  setSchedule(newSchedule);
                  
            }
        } catch (error) {
           // navigate('/qr_order/adminLogin');
        }
    };
    fetchMenuGroup();
  }, []);

 // 处理选择项目变化
 const handleSelectChange = (list) => {
    setSelectedItems(list);
  };

  // 显示创建分组的模态框
  const showGroupModal = () => {
    setIsModalVisible(true);
    setGroupName('');
    setSelectedItems([]);
  };

  // 处理创建分组
  const handleOk = () => {

    try {
        const token = sessionStorage.getItem('jwtToken');
        const config = {
          headers: {
            authorization: `Bearer ${token}`,
          },
        };
        if (selectedItems.length === 0) {
            notification.error({
                message: 'Create Failed',
                description: 'Please select at least one item.',
                });
                return;
        }
        
        axios.post(`${process.env.REACT_APP_SERVER_URL}/create-menu-group-category`, {groupName, selectedItems}, config)
        .then((response) => {
          if (response.status === 200) {
            notification.success({
                message: 'Create Success',
                description: 'The category has been successfully created.',
                });
                setIsModalVisible(false);
                setGroupName('');
                setSelectedItems([]);
            setExistingGroup(processExistingCategoryData(response.data.MenuGroupCategoryResult));
          }
        })
        
        
    }
    catch (error) {
        notification.error({
            message: 'Create Failed',
            description: 'An error occurred while creating the category.',
            });

      //navigate('/qr_order/adminLogin');
    
  };
};

  // 取消创建分组
  const handleCancel = () => {
    setIsModalVisible(false);
    setGroupName('');
    setSelectedItems([]);
  };



  // 添加时间段
  const addTimeSlot = (day) => {
    const newSchedule = schedule.map(d =>
      d.day === day ? { ...d, timeSlots: [...d.timeSlots, { group: '', time: '', isModified: true }] } : d
    );
    setSchedule(newSchedule);
  };
  // 修改时间段设置
  const handleTimeSlotChange = (value, index, key, day) => {
    console.log(value, index, key, day);
    const updatedSchedule = schedule.map((d) => {
      if (d.day === day) {
        const updatedTimeSlots = [...d.timeSlots];
        const updatedSlot = { ...updatedTimeSlots[index], [key]: value, isModified: true }; // 设置 isModified 为 true
        updatedTimeSlots[index] = updatedSlot;
        return { ...d, timeSlots: updatedTimeSlots };
      }
      return d;
    });
    console.log(updatedSchedule);
    setSchedule(updatedSchedule);
  };
  
  const handleSaveSchedule = async () => {
  
   //允许跨天时间段，移除 start time < end time 的限制

    const allSlotsValid = schedule.every(day => { // 检查每个日期的时间段
        return day.timeSlots.every(slot => { // 检查每个时间段
            return slot.group && slot.startTime && slot.endTime; // 移除时间大小比较的限制
        });
    });
    if (!allSlotsValid) {
        notification.error({ message: 'Please make sure all time slots have group, start time and end time selected' });
        return;
    }
    const allSlots = schedule.flatMap(day => day.timeSlots.map(slot => ({ day: day.day, ...slot })));
    console.log(allSlots);
    
    try {
      const token = sessionStorage.getItem('jwtToken');
      
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/save-time-slots`, { timeSlots: allSlots }, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        console.log(response.data.savedTimeSlotsResult);
//         //[
//     {
//         "CategoryId": null,
//         "CategoryName": "12",
//         "StoreId": 209,
//         "ServiceType": null,
//         "TimeSlotId": null,
//         "DayOfWeek": null,
//         "StartTime": null,
//         "EndTime": null
//     },
//     {
//         "CategoryId": 19,
//         "CategoryName": "1234",
//         "StoreId": 209,
//         "ServiceType": null,
//         "TimeSlotId": 8,
//         "DayOfWeek": "Monday",
//         "StartTime": "02:05:00",
//         "EndTime": "02:06:00"
//     }
// ]//
        const newSchedule = schedule.map(day => {
            const savedTimeSlots = response.data.savedTimeSlotsResult.filter(slot => slot.DayOfWeek === day.day);
            return { ...day, timeSlots: savedTimeSlots.map(slot => ({ group: slot.CategoryId, startTime: slot.StartTime, endTime: slot.EndTime })) };
        });
        setSchedule(newSchedule);
        notification.success({ message: 'Schedule saved successfully' });
        // 这里可以添加逻辑来更新状态或UI，例如清除isModified标志
      } else {
        throw new Error('Failed to save');
      }
    } catch (error) {
      notification.error({ message: 'An error occurred while saving the schedule' });
    }
  };
  const deleteTimeSlot = async (day, slotIndex) => {
    const daySchedule = schedule.find(d => d.day === day);
    const slot = daySchedule.timeSlots[slotIndex];

    // 如果是新添加的时间段，还未保存到服务器
    if (slot.isModified) {
        const newTimeSlots = daySchedule.timeSlots.filter((_, index) => index !== slotIndex);
        const newSchedule = schedule.map(d => d.day === day ? { ...d, timeSlots: newTimeSlots } : d);
        setSchedule(newSchedule);
        return;
    }

    // 如果时间段已保存到服务器，发送删除请求
    try {
        const token = sessionStorage.getItem('jwtToken');
        const config = {
          headers: {
            authorization: `Bearer ${token}`,
          },
        };
        
        const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/delete-time-slot/${slot.timeSlotId}`, config);
        if (response.status === 200) {
            notification.success({ message: 'Time slot deleted successfully' });
            
            const newTimeSlots = daySchedule.timeSlots.filter((_, index) => index !== slotIndex);
            const newSchedule = schedule.map(d => d.day === day ? { ...d, timeSlots: newTimeSlots } : d);
          
            setSchedule(newSchedule);
        } else {
            throw new Error('Failed to delete');
        }
    } catch (error) {
        notification.error({ message: 'An error occurred while deleting the time slot' });
    }
};

const handleRangeChange = (values, slotIndex, day) => {
    console.log(values, slotIndex, day);
    if (values && values.length === 2) {
        const [startTime, endTime] = values;
        console.log(startTime, endTime);
        // 格式化 startTime 和 endTime 为字符串格式 'HH:mm'
        const formattedStartTime = startTime ? dayjs(startTime).format('HH:mm') : null;
        const formattedEndTime = endTime ? dayjs(endTime).format('HH:mm') : null;
        console.log(formattedStartTime, formattedEndTime);

        setSchedule(currentSchedule => currentSchedule.map(d => {
            if (d.day === day) {
                return {
                    ...d,
                    timeSlots: d.timeSlots.map((slot, index) => {
                        if (index === slotIndex) {
                            return { 
                                ...slot, 
                                startTime: formattedStartTime, 
                                endTime: formattedEndTime,
                                isModified: true // 标记为已修改
                            };
                        }
                        return slot;
                    })
                };
            }
            
            return d;
        }));
        
    }
};

  

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
    <AppHeader email={cusEmail} cusId={cusId} />
  
    <div className='table_list'>
      <div className= 'admin_store_config' >
        <h2>Menu Group Management</h2>
        
    
      <Button  onClick={showGroupModal}>Create Group Category</Button>
      <Modal title="Create New Menu Group Category" open={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <Input placeholder="Group Category Name" value={groupName} onChange={(e) => setGroupName(e.target.value)} />
        <Checkbox.Group value={selectedItems} style={{ width: '100%' }} onChange={handleSelectChange}>
  <List
    dataSource={menuGroupItems}
    renderItem={item => (
      <List.Item>
        <Checkbox value={item.ItemId}>{item.Description}</Checkbox>
      </List.Item>
    )}
  />
</Checkbox.Group>

      </Modal>
  
      <div className="group-list">
        <Divider orientation="left" orientationMargin="0">
        
        </Divider>

        <Table columns={columns} dataSource={existingGroup} rowKey="CategoryId" />
      </div>
  
      <div className="table_list">
        
        <Divider orientation="left" orientationMargin="0">
          Schedule Menu Group
        </Divider>
  
{schedule.map(({ day, timeSlots }, index) => (
  <React.Fragment key={day}>
    {index !== 0 && <Divider />}
    <div style={{ marginBottom: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', justifyContent: 'start', flexWrap: 'wrap', gap: '8px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{day}</div>
        <Button type="primary" size="small" onClick={() => addTimeSlot(day)}>Add Time Slot</Button>
      </div>
      
      {timeSlots.map((slot, slotIndex) => (
      <div key={slotIndex} className="time-slot-row" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px', padding: '8px', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
        <Select
          value={slot.group}
          style={{ minWidth: 120, flex: '1 1 auto' }}
          onChange={(value) => handleTimeSlotChange(value, slotIndex, 'group', day)}
          placeholder="Select Group">
          {existingGroup.map(group => (
            <Option key={group.CategoryId} value={group.CategoryId}>{group.CategoryName}</Option>
          ))}
        </Select>

        <RangePicker
          value={[slot.startTime ? dayjs(slot.startTime, 'HH:mm') : null, slot.endTime ? dayjs(slot.endTime, 'HH:mm') : null]}
          format="HH:mm"
          onChange={(values) => handleRangeChange(values, slotIndex, day)}
          style={{ flex: '1 1 auto', minWidth: 200 }}
          picker="time"
          placeholder={['Start Time', 'End Time']}
        />

        <Button type="link" danger onClick={() => deleteTimeSlot(day, slotIndex)}>Delete</Button>
      </div>
    ))}


    </div>

  </React.Fragment>
))}

    <Button type="primary" onClick={handleSaveSchedule} style={{ marginTop: '20px' }}>Save</Button>
<div style={{ marginTop: '40px' }}>
</div>
      </div>
      </div>
    </div>
  </Layout>
  
  );
};

export default AdminMenuGroup;
